import { useEffect } from 'react';
import { KMStackEvent, eventBus } from '../utils';

export function useEventBusHandlers(handlers: {
  [K in KMStackEvent]?: (data: any) => void;
}) {
  useEffect(() => {
    // Subscribe all
    Object.entries(handlers).forEach(([event, handler]) => {
      eventBus.subscribe(event as KMStackEvent, handler);
    });

    // Cleanup on unmount
    return () => {
      Object.entries(handlers).forEach(([event, handler]) => {
        eventBus.unsubscribe(event as KMStackEvent, handler);
      });
    };
  }, [handlers]);
}
